import { combineReducers } from 'redux';

import balances from './reducers/balances';
import report from './reducers/report';
import reportOpts from './reducers/report-options';
import selectedCurrency from './reducers/selected-currency';
import selectedEvents from './reducers/selected-events';
import selectedEventsModal from './reducers/selected-events-modal';
import selectedTime from './reducers/selected-time';
import salesChartError from './reducers/sales-chart-error';

import ui from './reducers/ui/';

const rootReducer = combineReducers({
  balances,
  report,
  reportOpts,
  selectedCurrency,
  selectedEvents,
  selectedEventsModal,
  selectedTime,
  salesChartError,
  ui,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducer.js